export const membershipPauseKeys = {
    all: ['membershipPause'] as const,
    /** 고정 키 — 화면을 열 때마다 바뀌지 않게 센터만 넣는다. */
    support: (centerId: string) => ['membershipPause', 'support', centerId] as const,
};
